import moment from 'moment';

/** A bill's service period is long past once it ended more than this many calendar months ago (LB-6030). */
export const OLD_SERVICE_PERIOD_MONTHS = 3;
function toDay(value) {
  if (!value) return null;
  const day = moment(value);
  return day.isValid() ? day.startOf('day') : null;
}

/**
 * True when the period ended before today less three calendar months: on 8 Oct, a period ending 7 Jul is long past and
 * one ending 8 Jul is not. property-service records a confirmation on the same rule, by its own date. A period with no
 * end date cannot be judged and is not long past.
 */
export function isOldServicePeriod(endDateOnly) {
  let today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment();
  const end = toDay(endDateOnly);
  if (!end) return false;
  return end.isBefore(moment(today).startOf('day').subtract(OLD_SERVICE_PERIOD_MONTHS, 'months'));
}

/** The period and how long ago it ended, as "Jul 26 – Aug 25, 2025, ended 13 months ago". */
export function describeOldServicePeriod(_ref) {
  let startDateOnly = _ref.startDateOnly,
    endDateOnly = _ref.endDateOnly;
  let today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment();
  const end = toDay(endDateOnly);
  if (!end) return '';
  const months = moment(today).startOf('day').diff(end, 'months');
  const ago = "".concat(months, " ").concat(months === 1 ? 'month' : 'months', " ago");
  const start = toDay(startDateOnly);
  if (!start) return "Ended ".concat(end.format('MMM D, YYYY'), ", ").concat(ago);
  return "".concat(start.format(start.year() === end.year() ? 'MMM D' : 'MMM D, YYYY'), " \u2013 ").concat(end.format('MMM D, YYYY'), ", ended ").concat(ago);
}